var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};

// react/plane-ticket-24.js
import React from "react";
import { i18n as i18n2 } from "@lingui/core";

// src/utils/i18n.ts
import { i18n } from "@lingui/core";
var supportedLocales = ["en", "nb", "fi", "da", "sv"];
var defaultLocale = "en";
var detectByBrand = () => {
  var _a;
  let value;
  switch ((_a = process == null ? void 0 : process.env) == null ? void 0 : _a.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname == null ? void 0 : hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale;
  }
};
var getSupportedLocale = (usedLocale) => {
  return supportedLocales.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost();
};
function detectLocale() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand();
    return getSupportedLocale(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost();
    if (!supportedLocales.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale(hostLocale);
    }
    return getSupportedLocale(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e) {
    console.warn("could not detect locale, falling back to source locale", e);
    return defaultLocale;
  }
}
var getMessages = (locale, enMsg, nbMsg, fiMsg, daMsg, svMsg) => {
  if (locale === "nb") return nbMsg;
  if (locale === "fi") return fiMsg;
  if (locale === "da") return daMsg;
  if (locale === "sv") return svMsg;
  return enMsg;
};
var activateI18n = (enMessages, nbMessages, fiMessages, daMessages, svMessages) => {
  const locale = detectLocale();
  const messages = getMessages(locale, enMessages, nbMessages, fiMessages, daMessages, svMessages);
  i18n.load(locale, messages);
  i18n.activate(locale);
};

// react/plane-ticket-24.js
var msgs = { "nb": { "icon.title.plane-ticket": ["H\xE5nd som holder flybillett"] }, "en": { "icon.title.plane-ticket": ["Hand with plane ticket"] }, "fi": { "icon.title.plane-ticket": ["Lentolippua pitelev\xE4 k\xE4si"] }, "da": { "icon.title.plane-ticket": ["H\xE5nd med flybillet"] }, "sv": { "icon.title.plane-ticket": ["Hand med flygbiljett"] } };
activateI18n(msgs.en, msgs.nb, msgs.fi, msgs.da, msgs.sv);
var title = i18n2.t({ message: `Hand with plane ticket`, id: "icon.title.plane-ticket", comment: "Title for plane ticket icon" });
var IconPlaneTicket24 = (attrs) => React.createElement("svg", __spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", viewBox: "0 0 24 24", dangerouslySetInnerHTML: { __html: `<title>${title}</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m7.198 14.321 1.645-1.234a1.543 1.543 0 0 1 2.209 2.09l-1.617 2.425a4.42 4.42 0 0 1-2.04 1.653l-2.383.955m-3.449 2.223v-4.991c0-.6.121-1.192.357-1.743l1.157-2.7a4.42 4.42 0 0 1 2.324-2.324L7.916 9.17"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M7.936 18.84v1.168c0 .56.233 1.097.647 1.493s.978.619 1.565.619H20.47c.586 0 1.149-.223 1.564-.619s.648-.933.648-1.493V3.112c0-.56-.233-1.097-.648-1.493A2.27 2.27 0 0 0 20.47 1h-2.212c0 .747-.31 1.463-.864 1.991a3.02 3.02 0 0 1-2.085.825 3.02 3.02 0 0 1-2.086-.825A2.75 2.75 0 0 1 12.36 1h-2.211c-.587 0-1.15.223-1.565.619a2.07 2.07 0 0 0-.647 1.493v10.736"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m11.903 9.939 1.36.79 5.709-2.794m-2.367 1.159L13.378 7.21m9.304 10.798h-2.95m-2.949 0h-2.212"></path>` } }, attrs));
var plane_ticket_24_default = IconPlaneTicket24;
export {
  IconPlaneTicket24,
  plane_ticket_24_default as default
};
//# sourceMappingURL=plane-ticket-24.js.map
